'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' });

var PresentToAll = function PresentToAll(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PresentToAll = (0, _pure2.default)(PresentToAll);
PresentToAll.muiName = 'SvgIcon';

exports.default = PresentToAll;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PresentToAll.js
// module id = 2741
// module chunks = 0